import { PREVIEW_SQL_SEGMENTS } from '../../../../core/theme/schemePreviewSample';
import { MONO_FONT_STACK } from '../../../../core/theme/fonts';
import type { EditorColorSchemeTokenColors } from '../../../../core/theme/monacoColorSchemes';

interface SchemePreviewProps {
  colors: EditorColorSchemeTokenColors;
  /** The real Monaco canvas color for this variant — `JAM_MONACO_DARK`/`JAM_MONACO_LIGHT`. */
  background: string;
  'data-testid'?: string;
}

/**
 * Pure, static preview of `PREVIEW_SQL_SEGMENTS` colored with `colors`, on a
 * frame painted `background`. Used by the Editor colors dialog's preview
 * panes — a cheap approximation, not a second live Monaco instance, so it
 * intentionally skips Monaco-only effects (bracket-pair colorization, etc.).
 */
export function SchemePreview({ colors, background, 'data-testid': testId }: SchemePreviewProps) {
  return (
    <pre
      data-testid={testId}
      className="m-0 overflow-x-auto rounded-md p-3 text-[12px] leading-5"
      style={{ backgroundColor: background, fontFamily: MONO_FONT_STACK, whiteSpace: 'pre' }}
    >
      {PREVIEW_SQL_SEGMENTS.map((line, lineIndex) => (
        <div key={lineIndex}>
          {line.map((segment, segIndex) => (
            <span key={segIndex} style={{ color: segment.token ? colors[segment.token] : colors.identifier }}>
              {segment.text}
            </span>
          ))}
        </div>
      ))}
    </pre>
  );
}
